import { ENDPOINTS } from "../../apiConfig";
import axiosRequest from "../universal/axiosService";

export const fetchAccountPaybles = async ({
  limit,
  page,
  filters,
  ret,
  ref,
  incl,
  sort,
}) => {
  try {
    // Make both API calls concurrently using axiosRequest
    const [accountpayblesResponse, totalCountResponse] = await Promise.all([
      axiosRequest({
        method: "GET",
        url: ENDPOINTS.ACCOUNT_PAYBLES.GET_ALL,
        params: {
          coll: "AccountPayable",
          lim: limit,
          pg: page,
          fil: JSON.stringify(filters),
          ret: ret,
          ref: ref,
          incl: incl,
          cache: false,
          sort: JSON.stringify(sort),
        },
      }),
    ]);
    return {
      data: accountpayblesResponse.data,
    };
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};
export const fetchOneAccountPayble = async ({
  accountPayableUiid,
  filters,
  retrieve,
  ref,
  incl,
}) => {
  const combinedFilters = {
    uiid: { type: "NONE", value: accountPayableUiid },
    ...filters,
  };
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.ACCOUNT_PAYBLES.GET_BY_UIID,
    params: {
      coll: "AccountPayable",
      ret: retrieve,
      ref,
      // fil: JSON.stringify({
      //   uiid: { type: "NONE", value: accountPayableUiid },
      // }),
      fil: JSON.stringify(combinedFilters),
      incl,
    },
  });
};
export const addNewAccountPayble = async (accountPayableData) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.ACCOUNT_PAYBLES.ADD_NEW,
    data: {
      syncToQb:true,
      coll: "AccountPayable",
      payload: accountPayableData,
    },
  });
};

export const updateAccountPayble = async ({
  coll,
  uiid,
  payload,
  patchId,
  tPath,
  syncFromQB,
  qbId
}) => {
  return await axiosRequest({
    method: "PATCH",
    url: ENDPOINTS.ACCOUNT_PAYBLES.UPDATE,
    params: {
      coll,
      uiid,
      ...(syncFromQB && { syncFromQB }),
      ...(qbId && { qbId }),
      ...(patchId && { patchId }),
      ...(tPath && { tPath }),
    },
    data: {
      payload,
    },
  });
};
